import { useEffect, useLayoutEffect, useState } from "react"
import { useSocketProvider } from "../../../../../Providers/SocketProvider"
import { Alert, AlertUpdate, isIndividualAlertUpdate, ServerAlert, TableOperation, toClientAlert } from "../Types/Alerts"
import { useSocketRoom } from "./useSocketRoom"

type useAlertsProps = {
    dataObjectId: number | undefined
}


export const useAlerts = ({ dataObjectId }: useAlertsProps) => {
    const { getDataQuerySocket } = useSocketProvider()
    const socket = getDataQuerySocket("default", { namespace: "/alerts" })
    const [alerts, setAlerts] = useState<Alert[]>([])

    // When the data object ID changes, clear the alerts before render
    useLayoutEffect(() => setAlerts([]), [dataObjectId])
    
    // Ensure we get updates for this data object
    useSocketRoom({ socket, room: dataObjectId })

    // Subscribe to realtime alert changes
    useEffect(() => {
        const listener = (alertUpdate: AlertUpdate) => {
            if (isIndividualAlertUpdate(alertUpdate)) {
                switch (alertUpdate.operation) {
                    case TableOperation.INSERT:
                        setAlerts(previous => [...previous, toClientAlert(JSON.parse(alertUpdate.data))])
                        break
                    case TableOperation.DELETE:
                        setAlerts(previous => {
                            const deletedAlert = (JSON.parse(alertUpdate.data) as ServerAlert)
                            return previous.filter(alert => alert.id !== deletedAlert.id)
                        })
                        break
                    case TableOperation.UPDATE:
                        setAlerts(previous => {
                            const updatedAlert = toClientAlert(JSON.parse(alertUpdate.data))
                            return previous.map(alert => alert.id === updatedAlert.id ? updatedAlert : alert)
                        })
                        break
                    default:
                        break
                }
            } else {
                setAlerts(Object.values(alertUpdate).map(serverAlerts => serverAlerts.map(toClientAlert)).flat())
            }
        }

        socket.on("alert_update", listener)

        return () => {
            socket.off("alert_update", listener)
        }
    }, [socket])

    return { alerts, setAlerts }
}